import { type PictogramIconProps } from './types';

// communication_08
export const Hierarchy = ({ color }: PictogramIconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 112 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.9215 30.3105C57.721 30.3105 58.3691 30.9587 58.3691 31.7582V55.8861H90.8936C91.1077 55.8861 91.311 55.9326 91.4939 56.0161C92.1441 56.1583 92.6308 56.7375 92.6308 57.4303V83.8745C92.6308 84.674 91.9826 85.3222 91.1831 85.3222C90.3836 85.3222 89.7354 84.674 89.7354 83.8745V58.7815H58.3691V83.8745C58.3691 84.674 57.721 85.3222 56.9215 85.3222C56.1219 85.3222 55.4738 84.674 55.4738 83.8745V58.7815H22.5633V83.8745C22.5633 84.674 21.9152 85.3222 21.1156 85.3222C20.3161 85.3222 19.668 84.674 19.668 83.8745V57.4303C19.668 56.8248 20.0397 56.3062 20.5673 56.0901C20.7842 55.9606 21.0377 55.8861 21.3087 55.8861H55.4738V31.7582C55.4738 30.9587 56.1219 30.3105 56.9215 30.3105Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M26.2302 91.8846C26.2302 94.6835 23.914 96.9997 21.1151 96.9997C18.3163 96.9997 16 94.6835 16 91.8846C16 89.0858 18.3163 86.7695 21.1151 86.7695C24.0105 86.673 26.2302 88.9893 26.2302 91.8846Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M61.9392 91.8846C61.9392 94.6835 59.6229 96.9997 56.8241 96.9997C54.0253 96.9997 51.709 94.6835 51.709 91.8846C51.709 89.0858 54.0253 86.7695 56.8241 86.7695C59.6229 86.673 61.9392 88.9893 61.9392 91.8846Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M96.2976 91.8846C96.2976 94.6835 93.9813 96.9997 91.1825 96.9997C88.3837 96.9997 86.0674 94.6835 86.0674 91.8846C86.0674 89.0858 88.3837 86.7695 91.1825 86.7695C93.9813 86.673 96.2976 88.9893 96.2976 91.8846Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M64.4489 21.6244C64.4489 25.8709 60.9745 29.2488 56.8245 29.2488C52.578 29.2488 49.2001 25.8709 49.2001 21.6244C49.2001 17.3779 52.6745 14 56.8245 14C60.9745 14 64.4489 17.3779 64.4489 21.6244Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};
